const SIGN_AUTH_MESSAGE = "Authentication message";

export default SIGN_AUTH_MESSAGE;
